import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content"]

  connect() {}

  toggle() {
    this.contentTarget.classList.toggle("hidden")
  }

  hide(event) {
    if (!this.element.contains(event.target) && !this.contentTarget.classList.contains("hidden")) {
      this.contentTarget.classList.add("hidden")
    }
  }
}
